import { render, staticRenderFns } from "./LoadingBar.vue?vue&type=template&id=201936b4&"
import script from "./LoadingBar.vue?vue&type=script&lang=ts&"
export * from "./LoadingBar.vue?vue&type=script&lang=ts&"
import style0 from "./LoadingBar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports